// 요금 페이지(/price)와 메인 페이지 요금 섹션이 함께 쓰는 커스텀 제작 안내표
export default function CustomPlanTable() {
  return (
    <>
      <div className="price-table-wrap reveal">
        <table className="price-table price-extra-table">
          <thead>
            <tr>
              <th>항목</th>
              <th>안내</th>
              <th>비용</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>앱 커스텀 기능</td>
              <td className="extra-desc">각 앱에 교회 전용 기능 추가</td>
              <td className="cost-cell">비용 협의</td>
            </tr>
            <tr>
              <td>홈페이지 제작</td>
              <td className="extra-desc">교회 홈페이지 추가 제작</td>
              <td className="cost-cell">비용 협의</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="price-note reveal">
        <p>필요한 기능과 범위를 알려 주시면 견적을 안내해 드립니다.</p>
      </div>
    </>
  );
}
